import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';

import { ReactComponent as LogoIcon } from '@/assets/breitling-simple.svg';

export const Placeholder = styled(Flex)<{ withBackground?: boolean }>`
  &&& {
    width: 100%;
    max-height: 100%;
    justify-content: center;
    align-items: center;
    margin: auto;
    background-color: ${({ theme, withBackground }) =>
      withBackground ? theme.colors.secondaryLightGrey : 'transparent'};
    overflow: hidden;

    img {
      min-height: 40px;
      height: auto;
      width: auto;
      max-width: 100%;
      max-height: 100%;
    }
    &.shopping-bag-strap-card {
      height: 100%;
    }
    &.carousel-image {
      height: 100%;
      img {
        height: 60%;
      }
    }
    &.watch-card,
    &.strap-card {
      img {
        height: 70%;
      }
    }

    &.cms-product-card {
      .loaded > img {
        height: 70%;
      }
    }
    ${({ theme }) => css`
      @media (max-width: ${theme.breakpoints.md}) {
        &.strap-card {
          max-height: 165px;
        }
      }

      ${theme.media.md.up} {
        &.watch-card {
          transform: translateX(10px);
        }
      }
    `}
  }
`;

export const Logo = styled(LogoIcon)`
  width: 15%;
`;
